<template>
  <div>
    <span v-if="!produto.$melhorPreco">
      {{ preco | currency('R$', casasDecimais) }}
      <div class="caption" v-if="isMoedaEstrangeira && showValorConvertido">
        {{ precoMoedaEstrangeira
          | currency(simboloMoeda, casasDecimais, configuracaoFormatacaoMoeda) }}
      </div>
      <small v-if="showPercentualIcms && icms">
        ({{ icms | number('0.00') }}%)
      </small>
    </span>
    <v-chip v-if="produto.$melhorPreco" label class="success my-1">
      {{ preco | currency('R$', casasDecimais) }}
      <small v-if="showPercentualIcms && icms">
        ({{ icms | number('0.00') }}%)
      </small>
    </v-chip>
    <px-show-is-homologado icon-size="13"
                           :produto="produto.produto.cotacaoProduto.produto"
                           :id-fornecedor="idFornecedor"/>
    <div v-if="isMoedaEstrangeira
         && showValorConvertido
         && produto.$melhorPreco"
         :class="`caption success white--text pl-3 mb-1 ${roundClass}`">
      {{ precoMoedaEstrangeira
        | currency(simboloMoeda, casasDecimais, configuracaoFormatacaoMoeda) }}
    </div>
  </div>
</template>

<script>
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    produto: Object,
    hideIcms: {
      type: Boolean,
      default: false,
    },
    showDifal: {
      type: Boolean,
      default: false,
    },
    showIpi: {
      type: Boolean,
      default: false,
    },
    showPercentualIcms: {
      type: Boolean,
      default: false,
    },
    showPrecoTarget: {
      type: Boolean,
      default: false,
    },
    showValorConvertido: {
      type: Boolean,
      default: false,
    },
    moeda: {
      type: String,
      default: 'BRL',
    },
  },
  computed: {
    preco() {
      let precoUnitarioField = this.produto.produto.precoSemTodos;
      if (this.hideIcms && this.showIpi && this.showDifal) {
        precoUnitarioField = this.produto.produto.precoComIpiDifal;
      }
      if (!this.hideIcms && this.showIpi && this.showDifal) {
        precoUnitarioField = this.produto.produto.precoComTodos;
      }
      if (this.hideIcms && this.showIpi && !this.showDifal) {
        precoUnitarioField = this.produto.produto.precoComIpi;
      }
      if (this.hideIcms && !this.showIpi && this.showDifal) {
        precoUnitarioField = this.produto.produto.precoComDifal;
      }
      if (!this.hideIcms && this.showIpi && !this.showDifal) {
        precoUnitarioField = this.produto.produto.precoComIcmsIpi;
      }
      if (!this.hideIcms && !this.showIpi && this.showDifal) {
        precoUnitarioField = this.produto.produto.precoComIcmsDifal;
      }
      if (!this.hideIcms && !this.showIpi && !this.showDifal) {
        precoUnitarioField = this.produto.produto.precoComIcms;
      }
      return precoUnitarioField;
    },
    precoMoedaEstrangeira() {
      return this.produto.produto.precoUnitario;
    },
    icms() {
      return this.produto.produto.impostos.icms
        ? currency(this.produto.produto.impostos.icms, { precision: DEFAULT_PRECISION })
          .multiply(100)
          .value
        : 0;
    },
    casasDecimais() {
      return this.produto.produto.cotacaoProduto.produto.casasDecimais || 2;
    },
    roundClass() {
      return this.casasDecimais <= 5 ? 'round-small-width' : 'round';
    },
    situacao() {
      return SituacaoRespostaCotacaoProduto.keys[this.produto.produto.situacao].description;
    },
    idFornecedor() {
      return this.produto.fornecedor ? this.produto.fornecedor.id : null;
    },
  },
};
</script>
<style scoped>
.round {
  width: 80%;
  border-radius: 3px;
}
.round-small-width {
  width: 60%;
  border-radius: 3px;
}
</style>
